export default "Toutes les aides pour la rénovation énergétique des copropriétés : MaPrimeRénov' Copropriété, CEE collectifs, Éco-PTZ collectif et aides locales. Cumuls et vote en assemblée générale.";
